var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiShiningFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 7.33329C4.3485 7.33329 7.33317 4.34863 7.33317 0.666626H8.6665C8.6665 4.34863 11.6512 7.33329 15.3332 7.33329V8.66663C11.6512 8.66663 8.6665 11.6513 8.6665 15.3333H7.33317C7.33317 11.6513 4.3485 8.66663 0.666504 8.66663V7.33329Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiShiningFill);
export default __webpack_public_path__ + "static/media/ri_shining-fill.4c90de476209099c98358a5c58a985c1.svg";
export { ForwardRef as ReactComponent };